import { expandRef, wrapRef } from '../../../../data';
import getFormatFromMime from '../../../helpers/get_format_from_mime';

export const documentUuid = docEl => docEl?.getAttribute('data-value')?.split('/')[0];

const fetchDocument = async uuid =>
  uuid ? expandRef(wrapRef('Cms::Content', { type: 'Document', id: uuid })) : undefined;

export const productTypeFromCategory = productCategory => {
  const text = (Array.isArray(productCategory) ? productCategory : [productCategory])
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  if (text.includes('door')) return 'doors';
  if (text.includes('window')) return 'windows';
  return undefined;
};

export const fileTypeFromMime = mime => {
  if (typeof mime !== 'string' || !mime) return undefined;
  const subtype = mime
    .split(';')[0]
    .split('/')
    .pop()
    .replace(/^(x-|vnd\.)/, '')
    .replace(/\+.*$/, '')
    .toLowerCase();
  return getFormatFromMime(mime) || subtype || undefined;
};

export const documentTrackingInfo = async docEl => {
  const doc = await fetchDocument(documentUuid(docEl));
  if (!doc) return {};
  return {
    productType: productTypeFromCategory(doc?.metadata?.settings?.attributes?.product_category),
    fileType: fileTypeFromMime(doc?.contents?.document?.mime_type),
  };
};
